module.exports = __webpack_public_path__ + "img/SAITARAPEAK.11219438.png";